import { ConfirmModal, DialogBox } from '@mummssoftware/common-ui';
import React from 'react';

import defaults from '../../translations/en.json';

const ModalPadding = <div style={{ height: '10px' }}></div>;

type IncidentConfirmModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const IncidentConfirmModal = ({
  open,
  onClose,
  onConfirm,
}: IncidentConfirmModalProps) => (
  <DialogBox
    open={open}
    disableScrollLock
    handleClick={onClose}
    title={defaults.ConfirmSubmission}
  >
    <ConfirmModal
      onOKClick={onConfirm}
      onCancelClick={onClose}
      okText={defaults.SUBMIT}
      noText={defaults.CANCEL}
      modalText={defaults.confirmIncidentWithoutDetails}
      content={ModalPadding}
    />
  </DialogBox>
);
